import { type CountryType, countries } from '@heidi/utils/countries';
import { useMemo } from 'react';
import { type Country, parsePhoneNumber } from 'react-phone-number-input';

/** Countries selectable in the phone input's country picker. */
export function useAllowedPhoneCountries(): Country[] {
  return useMemo(
    () => countries.filter((c) => !!c.countryCode).map((c) => c.countryCode as Country),
    []
  );
}

/**
 * True when the entered phone number parses to a different country than the
 * one selected in the form — drives the mismatch warning under the phone
 * field. Computed by the step (not internally) because the value also feeds
 * the step-level error-impression analytics.
 */
export function useCountryPhoneMismatch(
  country: CountryType | null,
  phoneNumber: string,
  showPhoneNumber: boolean
): boolean {
  return useMemo(() => {
    if (!country || !phoneNumber || !showPhoneNumber) return false;
    try {
      const parsed = parsePhoneNumber(phoneNumber);
      if (parsed?.country) {
        return parsed.country !== country.countryCode;
      }
    } catch {
      return false;
    }
    return false;
  }, [country, phoneNumber, showPhoneNumber]);
}
